import { render, staticRenderFns } from "./clientUsersEditModal.vue?vue&type=template&id=e60e132e"
import script from "./clientUsersEditModal.vue?vue&type=script&lang=js"
export * from "./clientUsersEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports